import React, { useEffect, useState } from "react";
import "./edit-profile-business.scss";
import { useWindowSize } from "react-use";
import FooterV2 from "../../components/FooterV2/FooterV2";
import BlinkingDots from "../../Animations/BlinkingDots/BlinkingDots";
import EditFullName from "./EditProfileComponents/EditFullName";
import EditEmailId from "./EditProfileComponents/EditEmailId";
import { useAuth } from "../../context/Auth/AuthState";
import EditBusinessContactPerson from "./EditBusinessProfileComponents/EditBusinessContactPerson";
import EditFirmBusinessEmailId from "./EditBusinessProfileComponents/EditFirmBusinessEmailId";
import EditContact from "./EditBusinessProfileComponents/EditContact";
import EditWhatsapp from "./EditBusinessProfileComponents/EditWhatsapp";
import EditBusinessUserName from "./EditBusinessProfileComponents/EditBusinessUserName";
import EditPassword from "./EditBusinessProfileComponents/EditPassword";
import EditCountry from "./EditBusinessProfileComponents/EditCountry";
import EditOwnerName from "./EditOwnerDetailsComponents/EditOwnerName";
import EditOwnerEmailId from "./EditOwnerDetailsComponents/EditOwnerEmailId";
import EditOwnerContact from "./EditOwnerDetailsComponents/EditOwnerContact";
import EditOwnerWhatsapp from "./EditOwnerDetailsComponents/EditOwnerWhatsapp";
import { plusicon } from "../../images";
import axios from "axios";
import config from "../../config/config";
import { toast } from "react-toastify";
import Joi from "joi";
import ToastMsg from "../../components/ToastMsg/ToastMsg";
// import { Link } from "react-router-dom";
// import { editProfileBusinessGst } from "../../components/helpers/constant-words";
import useTheme from "../../components/useTheme/useTheme";
// import FooterV2 from "../../components/FooterV2/FooterV2";

const EditProfileBusiness = () => {
  const { theme } = useTheme();
  const { width } = useWindowSize();
  const auth = useAuth();

  const [ownersData, setOwnersData] = useState([]);
  const [ownersErrors, setOwnersErrors] = useState([]);
  const base_url = config.api_url;

  const handleOwnersDetailsChange = (index, field, value) => {
    setOwnersData((prev) => {
      const updated = [...prev];
      updated[index][field] = value;
      return updated;
    });
  };

  const addOwner = () => {
    setOwnersData((prev) => [
      ...prev,
      {
        name: "",
        email: "",
        country_code: "91",
        phone: "",
        whatsapp_country_code: "91",
        whatsapp_no: "",
      },
    ]);
  };

  // console.log("Auth", auth);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (auth?.user?.owners.length > 0) {
      setOwnersData(auth?.user?.owners);
    }
  }, [auth?.user?.owners]);

  const ownerSchema = Joi.object({
    name: Joi.string().trim().required().messages({
      "string.empty": "Owner name cannot be empty",
      "any.required": "Owner name is required",
    }),
    email: Joi.string()
      .trim()
      .email({ tlds: { allow: false } })
      .required()
      .messages({
        "string.empty": "Email cannot be empty",
        "string.email": "Enter a valid email address",
        "any.required": "Email is required",
      }),
    phone: Joi.string().pattern(/^\d+$/).length(10).required().messages({
      "string.empty": "Phone number is required",
      "string.pattern.base": "Phone number must contain digits only",
      "string.length": "Phone number must be exactly 10 digits",
    }),
    country_code: Joi.string().required(),
    whatsapp_no: Joi.string().pattern(/^\d+$/).length(10).required().messages({
      "string.empty": "WhatsApp number is required",
      "string.pattern.base": "WhatsApp number must contain digits only",
      "string.length": "WhatsApp number must be exactly 10 digits",
    }),
    whatsapp_country_code: Joi.string().required(),
  }).unknown(true);

  const handleUpdateOwners = async () => {
    const errors = ownersData.map((owner, index) => {
      const { error } = ownerSchema.validate(owner, { abortEarly: false });
      if (!error) return {};

      const ownerErrors = {};
      error.details.forEach((detail) => {
        ownerErrors[detail.path[0]] = detail.message;
      });
      return ownerErrors;
    });

    setOwnersErrors(errors);

    const hasErrors = errors.some(
      (ownerErr) => Object.keys(ownerErr).length > 0
    );

    if (hasErrors) {
      toast(
        <ToastMsg
          message="Please fix validation errors before submitting"
          danger={true}
        />,
        config.error_toast_config
      );
      return; // API call blocked
    }

    // ✅ All validation passed — make API call
    try {
      const { data, status } = await axios.put(
        `${base_url}/business/update-owners/${auth?.user?._id}`,
        { owners: ownersData }
      );

      if (data.status && data.status !== 200) {
        toast(
          <ToastMsg
            message={data.message || "Something went wrong"}
            danger={true}
          />,
          config.error_toast_config
        );
        return; // Stop further execution
      }

      // Success
      toast(
        <ToastMsg message={data.message || "Owner details updated"} />,
        config.success_toast_config
      );

      // Refresh user info
      const { data: updatedUser } = await axios.get(
        `${base_url}/business/edit-profile/${auth?.user?._id}`
      );
      auth.refresh(updatedUser.data);
    } catch (err) {
      toast(
        <ToastMsg
          message={err.response?.data?.message || "Something went wrong"}
          danger={true}
        />,
        config.error_toast_config
      );
    }
  };

  const deleteOwner = async (ownerId, index) => {
    try {
      if (ownerId) {
        await axios.delete(
          `${base_url}/business/delete-owner/${auth?.user?._id}/${ownerId}`
        );
      }

      setOwnersData((prev) => prev.filter((_, i) => i !== index));

      toast(
        <ToastMsg message="Owner deleted successfully" />,
        config.success_toast_config
      );

      // Refresh user
      const { data: updatedUser } = await axios.get(
        `${base_url}/business/edit-profile/${auth?.user?._id}`
      );
      auth.refresh(updatedUser.data);
    } catch (err) {
      toast(
        <ToastMsg
          message={err.response?.data?.message || "Failed to delete owner"}
          danger={true}
        />,
        config.error_toast_config
      );
    }
  };

  return (
    <>
      <main
        className={`edit_container-business edit_container-business-mob ${
          theme === "dark" ? "edit_container-business--mode-dark" : ""
        }`}
      >
        <section className="edit_sec1">
          <div className="my_container">
            <div className="row">
              {/* <div className="col-md-3 d-md-block d-lg-block"> */}
                <div className="col-md-3 d-none d-md-block d-lg-block">
                <p className="title">My Account</p>
                <ul className="account_list">
                  <li className="list-item">Edit Your Profile</li>
                  {/* <li className="list-item">
                    <Link to={editProfileBusinessGst}>Edit GST</Link>
                  </li> */}
                </ul>
              </div>
              <div className="col-md-9">
                <div className="role_wrap">
                  <p className="role_title">YOUR ROLE</p>
                  <p
                    className="user_role"
                    style={{ color: auth?.user?.userType?.color }}
                  >
                    {auth?.user?.userType?.name}
                  </p>
                </div>
                <div className="profile_form_container">
                  <div className={`row ${width < 600 && "gx-0"}`}>
                    <div className={`col-lg-6 ${width > 992 && "ps-0"}`}>
                      <EditBusinessContactPerson
                        lightTheme={theme === "light" ? true : false}
                      />
                    </div>
                    <div className={`col-lg-6 ${width > 992 && "pe-0"}`}>
                      <EditFirmBusinessEmailId lightTheme={theme === "light" ? true : false}/>
                    </div>
                    <div className={`col-lg-6 ${width > 992 && "ps-0"}`}>
                      <EditContact lightTheme={theme === "light" ? true : false} user={auth?.user} />
                    </div>
                    <div className={`col-lg-6 ${width > 992 && "pe-0"}`}>
                      <EditWhatsapp lightTheme={theme === "light" ? true : false} />
                    </div>
                    <div className={`col-lg-6 ${width > 992 && "ps-0"}`}>
                      <EditBusinessUserName lightTheme={theme === "light" ? true : false}/>
                    </div>
                    <div className={`col-lg-6 ${width > 992 && "pe-0"}`}>
                      <EditPassword lightTheme={theme === "light" ? true : false} />
                    </div>
                    <div className={`col-lg-6 ${width > 992 && "ps-0"}`}></div>
                    <div className={`col-lg-12 ${width > 992 && "p-0"}`}>
                      <EditCountry lightTheme={theme === "light" ? true : false}/>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 hr_line"></div>

              <div className="col-md-3 d-none d-md-block d-lg-block"></div>
              <div className="col-md-9">
                <div className="role_wrap">
                  <p className="role_title owner_details">Owner Details</p>
                  <p
                    className="user_role"
                    style={{ color: auth?.user?.userType?.color }}
                  >
                    {auth?.user?.userType?.name}
                  </p>
                </div>

                {/* Edit Owner Details */}

                {ownersData?.map((owner, i) => {
                  const ownerErr = ownersErrors[i] || {};
                  const {
                    name,
                    email,
                    country_code,
                    phone,
                    whatsapp_country_code,
                    whatsapp_no,
                    _id: id,
                  } = owner;

                  return (
                    <>
                      <div className="profile_form_container" key={i}>
                        <div className={`row ${width < 600 && "gx-0"}`}>
                          <div className={`col-lg-6 ${width > 992 && "ps-0"}`}>
                            <EditOwnerName
                              value={name}
                              lightTheme={theme === "light" ? true : false}
                              error={ownerErr.name}
                              onChange={(val) =>
                                handleOwnersDetailsChange(i, "name", val)
                              }
                            />
                          </div>
                          <div className={`col-lg-6 ${width > 992 && "ps-0"}`}>
                            <EditOwnerEmailId
                              value={email}
                             lightTheme={theme === "light" ? true : false}
                              error={ownerErr.email}
                              onChange={(val) =>
                                handleOwnersDetailsChange(i, "email", val)
                              }
                            />
                          </div>
                          <div className={`col-lg-6 ${width > 992 && "ps-0"}`}>
                            <EditOwnerContact
                              lightTheme={theme === "light" ? true : false}
                              country_code={country_code}
                              phone={phone}
                              error={ownerErr.phone}
                              onChange={(field, val) =>
                                handleOwnersDetailsChange(i, field, val)
                              }
                            />
                          </div>
                          <div className={`col-lg-6 ${width > 992 && "ps-0"}`}>
                            <EditOwnerWhatsapp
                              lightTheme={theme === "light" ? true : false}
                              whatsapp_country_code={whatsapp_country_code}
                              whatsapp_no={whatsapp_no}
                              contact_country_code={country_code}
                              contact_phone={phone}
                              error={ownerErr.whatsapp_no}
                              onChange={(field, val) =>
                                handleOwnersDetailsChange(i, field, val)
                              }
                              onDelete={() => deleteOwner(id, i)}
                            />
                          </div>
                        </div>
                      </div>

                      {i !== ownersData.length - 1 && (
                        <div className="hr_line_owner_details"></div>
                      )}
                    </>
                  );
                })}

                {/* <div className="add_more">
                  <p className="add_owner">Add Owner</p>
                </div> */}

                <div
                  className="add_new_owner_action_wrapper"
                  onClick={addOwner}
                >
                  <img
                    src={plusicon}
                    alt="Add location"
                    className="add_location_wrapper"
                  />
                  <div className="text_action_add_location">Add more Owner</div>
                </div>

                <button
                  onClick={handleUpdateOwners}
                  className="popup_common_btn"
                >
                  Update Owner Details
                </button>

                {/* <div className="profile_form_container">
                  <div className={`row ${width < 600 && "gx-0"}`}>
                    <div className={`col-lg-6 ${width > 992 && "ps-0"}`}>
                      <EditOwnerName lightTheme={theme !== "dark"}/>
                    </div>
                    <div className={`col-lg-6 ${width > 992 && "ps-0"}`}>
                      <EditOwnerEmailId lightTheme={theme !== "dark"} />
                    </div>
                    <div className={`col-lg-6 ${width > 992 && "ps-0"}`}>
                      <EditOwnerContact lightTheme={theme !== "dark"} user={auth?.user} />
                    </div>
                    <div className={`col-lg-6 ${width > 992 && "ps-0"}`}>
                      <EditOwnerWhatsapp lightTheme={theme !== "dark"} />
                    </div>
                  </div>
                </div> */}

                {/* <div className="profile_form_container">
                  <div className={`row ${width < 600 && "gx-0"}`}>
                    <div className={`col-lg-6 ${width > 992 && "ps-0"}`}>
                      <EditOwnerName lightTheme={theme !== "dark"} />
                    </div>
                    <div className={`col-lg-6 ${width > 992 && "ps-0"}`}>
                      <EditOwnerEmailId lightTheme={theme !== "dark"} />
                    </div>
                    <div className={`col-lg-6 ${width > 992 && "ps-0"}`}>
                      <EditOwnerContact lightTheme={theme !== "dark"} user={auth?.user} />
                    </div>
                    <div className={`col-lg-6 ${width > 992 && "ps-0"}`}>
                      <EditOwnerWhatsapp lightTheme={theme !== "dark"} />
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </section>
        {theme === "dark" ? <FooterV2 whatsappBotIcon={false} /> : <FooterV2 lightTheme whatsappBotIcon={false} />}
      </main>
    </>
  );
};
export default EditProfileBusiness;
